module.exports = __webpack_public_path__ + "a50c754e411339beaa1fb1f94e794b77.MP3";